import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import { ErrorBoundary } from './components/ErrorBoundary'
import { CardSkeleton } from './components/Skeleton'

// Lazy load pages for code splitting
const StemSeparationPage = lazy(() => import('./pages/StemSeparationPage'))
const MasteringPage = lazy(() => import('./pages/MasteringPage'))
const AnalysisPage = lazy(() => import('./pages/AnalysisPage'))
const VoiceConversionPage = lazy(() => import('./pages/VoiceConversionPage'))
const HistoryPage = lazy(() => import('./pages/HistoryPage'))

// Loading fallback component
function PageLoader() {
  return (
    <div className="space-y-6 p-8" aria-busy="true" aria-label="Loading page">
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
    </div>
  )
}

function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <Layout>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/stems" element={<StemSeparationPage />} />
              <Route path="/mastering" element={<MasteringPage />} />
              <Route path="/analysis" element={<AnalysisPage />} />
              <Route path="/voice" element={<VoiceConversionPage />} />
              <Route path="/history" element={<HistoryPage />} />
            </Routes>
          </Suspense>
        </Layout>
      </ErrorBoundary>
    </HelmetProvider>
  )
}

export default App
